<template>
  <div id="Wizualizacja">
    <!-- {{(Number(outputs.szafa_wolne_miejsce.value) / 3)}} -->
    <!-- {{outputs.keyGen.value}} -->
    <div id="szafa">
      <div id="szafa-top" :style="BgImageTop('szafa/szafa_dso_' +iloscU+ '.svg')">
        <div id="grupa_otworow">
          <div class="wentylator"
          v-if="iloscAkumulatorow.value > 0 && (inputs.panel_wentylacyjny.value === '1' || inputs.panel_wentylacyjny.value === 1)"
          :style="{top: '-20px', left: '0px' }"></div>

          <div id="szafa-elementy" style="width: 250px; position: absolute; bottom:0px">
            <div v-if="iloscAkumulatorow.value > 0 && showPanelZaslepiajacy > 0" class="zaslepka" :style="{bottom: showPanelZaslepiajacy + 'px', left: '0px' }"></div>

            <div id="wolne-miejsce" class="wolne-miejsce" :style="{bottom: startWolneMiejsce +'px', left: '0px', height: (Number(inputs.dodatkowe_u.value) * 15) + 'px' }">
            </div>
            <div id="cluster1" style="position:relative; bottom:0px">
              <div v-for="(item, index) in devices_cluster_1" :key='index'
              :class="item.grupa"
              @change="cosik(index)"
              :style="{bottom: item.top + 'px', left: '0px', height: (item.wysokosc * 15) + 'px' }"></div>
            </div>
            <div id="cluster2" style="position:relative; bottom:0px">
              <div v-for="(item, index) in devices_cluster_2" :key='index'
              :class="item.grupa"
              :style="{bottom: item.top + 'px', left: '0px', height: (item.wysokosc * 15) + 'px' }"></div>
            </div>
            <div id="cluster3" style="position:relative; bottom:0px">
              <div v-for="(item, index) in devices_cluster_3" :key='index'
              :class="item.grupa"
              :style="{bottom: item.top + 'px', left: '0px', height: (item.wysokosc * 15) + 'px' }"></div>
            </div>
            <div id="cluster4" style="position:relative; bottom:0px">
              <div v-for="(item, index) in devices_cluster_4" :key='index'
              :class="item.grupa"
              :style="{bottom: item.top + 'px', left: '0px', height: (item.wysokosc * 15) + 'px' }"></div>
            </div>
            <div id="cluster5" style="position:relative; bottom:0px">
              <div v-for="(item, index) in devices_cluster_5" :key='index'
              :class="item.grupa"
              :style="{bottom: item.top + 'px', left: '0px', height: (item.wysokosc * 15) + 'px' }"></div>
            </div>
            <div id="cluster6" style="position:relative; bottom:0px">
              <div v-for="(item, index) in devices_cluster_6" :key='index'
              :class="item.grupa"
              :style="{bottom: item.top + 'px', left: '0px', height: (item.wysokosc * 15) + 'px' }"></div>
            </div>
            <div v-if="iloscAkumulatorow.value > 0 && inputs.polka_mikrofon.value > 0" class="mikrofon" :style="[{bottom: heightMikrofonMount + 'px', left: '0px' }]"></div>
            <div v-if="iloscAkumulatorow.value > 0" class="panel_sygnalizacyjny" :style="[{bottom: heightPanelMount + 'px', left: '0px' }]"></div>
            <div v-if="iloscAkumulatorow.value > 0" class="listwa" :style="[{bottom: heightListwa + 'px', left: '0px' }, BgImageTop(getImgUrlListwa)]"></div>

            <template v-if="sprawdzAkumulatoryNaPolkach.length > 0">
                <div class="akumulator" v-for="(item,index) in sprawdzAkumulatoryNaPolkach.length" :key = index
                :style="[{bottom: (index * heightAkumulator) + topAkumulator + 'px', left: '0px', height: heightAkumulator + 'px'}]">
                  <div v-if="sprawdzAkumulatoryNaPolkach[index].length > 0 && sprawdzAkumulatoryNaPolkach[index][0]" class="akumulator_left"
                    :style="[BgImageAkumulator(sprawdzAkumulatoryNaPolkach[index][0])]"><span class="pojAkum">{{sprawdzAkumulatoryNaPolkach[index][0]}}Ah</span></div>
                  <div v-if="sprawdzAkumulatoryNaPolkach[index].length > 0 && sprawdzAkumulatoryNaPolkach[index][1]" class="akumulator_right"
                    :style="[BgImageAkumulator(sprawdzAkumulatoryNaPolkach[index][1])]"><span class="pojAkum">{{sprawdzAkumulatoryNaPolkach[index][1]}}Ah</span></div>
                  <div v-if="sprawdzAkumulatoryNaPolkach[index].length > 0 && sprawdzAkumulatoryNaPolkach[index][2]" class="akumulator_back"
                    :style="[BgImageAkumulatorPoziom(sprawdzAkumulatoryNaPolkach[index][2])]"><span class="pojAkum">{{sprawdzAkumulatoryNaPolkach[index][2]}}Ah</span></div>
                  <div class="polka_akumulator"></div>
                </div>
            </template>
          </div>

          <div v-for="(pole, index) in Number(iloscU * 3)" :key="index" :data-id="Number(iloscU * 3) - index"
            class="otwory_montazowe"><span v-if="Number.isInteger(Number(index) / 3)"
            style="font-size: 10px;
              height: 8px;
              line-height: 10px;
              position: absolute;
              margin-left: -15px;">
              {{iloscU - (index / 3)}}
            </span>
          </div>
        </div>
      </div>
      <div id="szafa-bottom" :style="BgImageBottom(imgKolka)"></div>
    </div>
    <div id="obudowy" v-if="inputs.obudowa_plytki.value > 0 || inputs.wariant3.value > 0 || inputs.wariant2.value > 0">
      <img v-if="inputs.obudowa_plytki.value > 0" src="../assets/img/urzadzenia/obudowa_plytki.png" style="width: 80%;"/>
      <img v-if="inputs.wariant3.value > 0" src="../assets/img/urzadzenia/wariant3.png" style="width: 85%;"/>
      <img v-if="inputs.wariant2.value > 0" src="../assets/img/urzadzenia/wariant2.png" style="width: 95%;"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../mixins/app'
// import { materials } from '../mixins/materials'
import { calculation } from '../mixins/calculation'

export default {
  name: 'Wizualizacja',
  mixins: [app, calculation],
  data () {
    return {
      clusterTop: 0,
      heightPanel: 0,
      heightCluster1: 0,
      heightCluster2: 0,
      heightCluster3: 0,
      heightCluster4: 0,
      heightCluster5: 0,
      backgroundUrl: require('../assets/img/szafa/szafa_dso_24.svg'),
      startWolneMiejsce: 0
    }
  },
  computed: {
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('app', ['clusters']),
    ...mapGetters('app', ['clusterOne']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaBosch']),
    ...mapGetters('products', ['ListaPulsar']),
    ...mapGetters('products', ['ListaAkumulatory']),
    ...mapGetters('products', ['ListaMaterialy']),
    getImgUrl () {
      var ilosc = (this.outputs.szafa.attributes.wysokosc === '') ? '24' : this.outputs.szafa.attributes.wysokosc
      return require('../assets/img/szafa/szafa_' + ilosc + '.png')
    },
    getImgUrlListwa () {
      var listwaUrl = ''

      if (this.inputs.przylacze_zasilania.active) {
        if (this.inputs['przylacze_zasilania'].value === 1) {
          listwaUrl = 'urzadzenia/listwa_1.png'
        } else if (this.inputs['przylacze_zasilania'].value === 3) {
          listwaUrl = 'urzadzenia/listwa_2.png'
        }
      } else {
        if (this.outputs.qtyClusters.value < 3) {
          listwaUrl = 'urzadzenia/listwa_1.png'
        } else if (this.outputs.qtyClusters.value > 2) {
          listwaUrl = 'urzadzenia/listwa_2.png'
        }
      }

      return listwaUrl
    },
    showPanelZaslepiajacy () {
      var index = 0
      if (this.inputs.panel_wentylacyjny.value === '1' || this.inputs.panel_wentylacyjny.value === 1) {
        index = Math.ceil((this.iloscU * 15)) - 30
        this.changeTop('panel', index)
        return Math.ceil((this.iloscU * 15)) - 15
      } else {
        index = Math.ceil((this.iloscU * 15)) - 15
        this.changeTop('panel', index)
        return 0
      }
    },
    devices_start_mounted () {
      return this.heightPanelMount + 15
    },
    devices_cluster_1 () {
      if (this.clusters.cluster1 && Object.keys(this.clusters.cluster1).length > 0) {
        var arr = []
        var index = 0
        // var otherIndex = 0

        if (this.inputs.polka_mikrofon.value > 0) {
          index = this.heightMikrofonMount + (5 * 15) // 5U
        } else {
          index = this.heightPanelMount + (1 * 15) // 1U
        }
        if (this.clusters.cluster1.powerSupply) {
          arr.push({'grupa': this.clusters.cluster1.powerSupply.grupa, 'wysokosc': this.clusters.cluster1.powerSupply.attributes.wysokosc, 'top': index})
          index += Number(this.clusters.cluster1.powerSupply.attributes.wysokosc) * 15
        }
        if (this.clusters.cluster1.output48three) {
          if (this.clusters.cluster1.output48three.attributes && this.clusters.cluster1.output48three.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster1.output48three.grupa === 'other') ? (Number(this.clusters.cluster1.output48three.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster1.output48three.grupa, 'wysokosc': this.clusters.cluster1.output48three.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster1.output48three.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster1.output48two) {
          if (this.clusters.cluster1.output48two.attributes && this.clusters.cluster1.output48two.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster1.output48two.grupa === 'other') ? (Number(this.clusters.cluster1.output48two.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster1.output48two.grupa, 'wysokosc': this.clusters.cluster1.output48two.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster1.output48two.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster1.output48one) {
          if (this.clusters.cluster1.output48one.attributes && this.clusters.cluster1.output48one.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster1.output48one.grupa === 'other') ? (Number(this.clusters.cluster1.output48one.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster1.output48one.grupa, 'wysokosc': this.clusters.cluster1.output48one.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster1.output48one.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster1.output24) {
          if (this.clusters.cluster1.output24.attributes && this.clusters.cluster1.output24.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster1.output24.grupa === 'other') ? (Number(this.clusters.cluster1.output24.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster1.output24.grupa, 'wysokosc': this.clusters.cluster1.output24.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster1.output24.attributes.wysokosc) * 15
          }
        }
        this.changeTop('c1', index)
        return arr
      } else {
        return []
      }
    },
    devices_cluster_2 () {
      if (this.clusters.cluster2 && Object.keys(this.clusters.cluster2).length > 0) {
        var arr = []
        var index = this.heightCluster1
        // var otherIndex = 0

        if (this.clusters.cluster2.powerSupply) {
          arr.push({'grupa': this.clusters.cluster2.powerSupply.grupa, 'wysokosc': this.clusters.cluster2.powerSupply.attributes.wysokosc, 'top': index})
          index += Number(this.clusters.cluster2.powerSupply.attributes.wysokosc) * 15
        }
        if (this.clusters.cluster2.output48three) {
          if (this.clusters.cluster2.output48three.attributes && this.clusters.cluster2.output48three.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster2.output48three.grupa === 'other') ? (Number(this.clusters.cluster2.output48three.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster2.output48three.grupa, 'wysokosc': this.clusters.cluster2.output48three.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster2.output48three.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster2.output48two) {
          if (this.clusters.cluster2.output48two.attributes && this.clusters.cluster2.output48two.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster2.output48two.grupa === 'other') ? (Number(this.clusters.cluster2.output48two.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster2.output48two.grupa, 'wysokosc': this.clusters.cluster2.output48two.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster2.output48two.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster2.output48one) {
          if (this.clusters.cluster2.output48one.attributes && this.clusters.cluster2.output48one.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster2.output48one.grupa === 'other') ? (Number(this.clusters.cluster2.output48one.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster2.output48one.grupa, 'wysokosc': this.clusters.cluster2.output48one.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster2.output48one.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster2.output24) {
          if (this.clusters.cluster2.output24.attributes && this.clusters.cluster2.output24.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster2.output24.grupa === 'other') ? (Number(this.clusters.cluster2.output24.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster2.output24.grupa, 'wysokosc': this.clusters.cluster2.output24.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster2.output24.attributes.wysokosc) * 15
          }
        }
        this.changeTop('c2', index)
        return arr
      } else {
        return []
      }
    },
    devices_cluster_3 () {
      if (this.clusters.cluster3 && Object.keys(this.clusters.cluster3).length > 0) {
        var arr = []
        // var index = this.clusterTop - 21.2 // (15 * 2)
        // var index = Math.ceil((this.iloscU * 15)) + 7
        var index = this.heightCluster2
        // var otherIndex = 0

        if (this.clusters.cluster3.powerSupply) {
          arr.push({'grupa': this.clusters.cluster3.powerSupply.grupa, 'wysokosc': this.clusters.cluster3.powerSupply.attributes.wysokosc, 'top': index})
          index += Number(this.clusters.cluster3.powerSupply.attributes.wysokosc) * 15
        }
        if (this.clusters.cluster3.output48three) {
          if (this.clusters.cluster3.output48three.attributes && this.clusters.cluster3.output48three.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster3.output48three.grupa === 'other') ? (Number(this.clusters.cluster3.output48three.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster3.output48three.grupa, 'wysokosc': this.clusters.cluster3.output48three.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster3.output48three.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster3.output48two) {
          if (this.clusters.cluster3.output48two.attributes && this.clusters.cluster3.output48two.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster3.output48two.grupa === 'other') ? (Number(this.clusters.cluster3.output48two.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster3.output48two.grupa, 'wysokosc': this.clusters.cluster3.output48two.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster3.output48two.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster3.output48one) {
          if (this.clusters.cluster3.output48one.attributes && this.clusters.cluster3.output48one.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster3.output48one.grupa === 'other') ? (Number(this.clusters.cluster3.output48one.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster3.output48one.grupa, 'wysokosc': this.clusters.cluster3.output48one.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster3.output48one.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster3.output24) {
          if (this.clusters.cluster3.output24.attributes && this.clusters.cluster3.output24.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster3.output24.grupa === 'other') ? (Number(this.clusters.cluster3.output24.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster3.output24.grupa, 'wysokosc': this.clusters.cluster3.output24.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster3.output24.attributes.wysokosc) * 15
          }
        }
        this.changeTop('c3', index)
        return arr
      } else {
        return []
      }
    },
    devices_cluster_4 () {
      if (this.clusters.cluster4 && Object.keys(this.clusters.cluster4).length > 0) {
        var arr = []
        // var index = this.clusterTop - 21.2 // (15 * 2)
        // var index = Math.ceil((this.iloscU * 15)) + 7
        var index = this.heightCluster3
        // var otherIndex = 0

        if (this.clusters.cluster4.powerSupply) {
          arr.push({'grupa': this.clusters.cluster4.powerSupply.grupa, 'wysokosc': this.clusters.cluster4.powerSupply.attributes.wysokosc, 'top': index})
          index += Number(this.clusters.cluster4.powerSupply.attributes.wysokosc) * 15
        }
        if (this.clusters.cluster4.output48three) {
          if (this.clusters.cluster4.output48three.attributes && this.clusters.cluster4.output48three.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster4.output48three.grupa === 'other') ? (Number(this.clusters.cluster4.output48three.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster4.output48three.grupa, 'wysokosc': this.clusters.cluster4.output48three.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster4.output48three.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster4.output48two) {
          if (this.clusters.cluster4.output48two.attributes && this.clusters.cluster4.output48two.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster4.output48two.grupa === 'other') ? (Number(this.clusters.cluster4.output48two.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster4.output48two.grupa, 'wysokosc': this.clusters.cluster4.output48two.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster4.output48two.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster4.output48one) {
          if (this.clusters.cluster4.output48one.attributes && this.clusters.cluster4.output48one.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster4.output48one.grupa === 'other') ? (Number(this.clusters.cluster4.output48one.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster4.output48one.grupa, 'wysokosc': this.clusters.cluster4.output48one.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster4.output48one.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster4.output24) {
          if (this.clusters.cluster4.output24.attributes && this.clusters.cluster4.output24.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster4.output24.grupa === 'other') ? (Number(this.clusters.cluster4.output24.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster4.output24.grupa, 'wysokosc': this.clusters.cluster4.output24.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster4.output24.attributes.wysokosc) * 15
          }
        }
        this.changeTop('c4', index)
        return arr
      } else {
        return []
      }
    },
    devices_cluster_5 () {
      if (this.clusters.cluster5 && Object.keys(this.clusters.cluster5).length > 0) {
        var arr = []
        // var index = this.clusterTop - (15 * 2)
        var index = this.heightCluster4
        // var otherIndex = 0

        if (this.clusters.cluster5.powerSupply) {
          arr.push({'grupa': this.clusters.cluster5.powerSupply.grupa, 'wysokosc': this.clusters.cluster5.powerSupply.attributes.wysokosc, 'top': index})
          index += Number(this.clusters.cluster5.powerSupply.attributes.wysokosc) * 15
        }
        if (this.clusters.cluster5.output48three) {
          if (this.clusters.cluster5.output48three.attributes && this.clusters.cluster5.output48three.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster5.output48three.grupa === 'other') ? (Number(this.clusters.cluster5.output48three.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster5.output48three.grupa, 'wysokosc': this.clusters.cluster5.output48three.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster5.output48three.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster5.output48two) {
          if (this.clusters.cluster5.output48two.attributes && this.clusters.cluster5.output48two.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster5.output48two.grupa === 'other') ? (Number(this.clusters.cluster5.output48two.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster5.output48two.grupa, 'wysokosc': this.clusters.cluster5.output48two.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster5.output48two.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster5.output48one) {
          if (this.clusters.cluster5.output48one.attributes && this.clusters.cluster5.output48one.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster5.output48one.grupa === 'other') ? (Number(this.clusters.cluster5.output48one.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster5.output48one.grupa, 'wysokosc': this.clusters.cluster5.output48one.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster5.output48one.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster5.output24) {
          if (this.clusters.cluster5.output24.attributes && this.clusters.cluster5.output24.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster5.output24.grupa === 'other') ? (Number(this.clusters.cluster5.output24.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster5.output24.grupa, 'wysokosc': this.clusters.cluster5.output24.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster5.output24.attributes.wysokosc) * 15
          }
        }
        this.changeTop('c5', index)
        return arr
      } else {
        return []
      }
    },
    devices_cluster_6 () {
      var arr = []
      if (this.clusters.cluster6 && Object.keys(this.clusters.cluster6).length > 0) {
      //   var index = this.clusterTop - (15 * 2)
        var index = this.heightCluster5
        // var otherIndex = 0

        if (this.clusters.cluster6.powerSupply) {
          arr.push({'grupa': this.clusters.cluster6.powerSupply.grupa, 'wysokosc': this.clusters.cluster6.powerSupply.attributes.wysokosc, 'top': index})
          index += Number(this.clusters.cluster6.powerSupply.attributes.wysokosc) * 15
        }
        if (this.clusters.cluster6.output48three) {
          if (this.clusters.cluster6.output48three.attributes && this.clusters.cluster6.output48three.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster6.output48three.grupa === 'other') ? (Number(this.clusters.cluster6.output48three.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster6.output48three.grupa, 'wysokosc': this.clusters.cluster6.output48three.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster6.output48three.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster6.output48two) {
          if (this.clusters.cluster6.output48two.attributes && this.clusters.cluster6.output48two.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster6.output48two.grupa === 'other') ? (Number(this.clusters.cluster6.output48two.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster6.output48two.grupa, 'wysokosc': this.clusters.cluster6.output48two.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster6.output48two.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster6.output48one) {
          if (this.clusters.cluster6.output48one.attributes && this.clusters.cluster6.output48one.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster6.output48one.grupa === 'other') ? (Number(this.clusters.cluster6.output48one.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster6.output48one.grupa, 'wysokosc': this.clusters.cluster6.output48one.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster6.output48one.attributes.wysokosc) * 15
          }
        }
        if (this.clusters.cluster6.output24) {
          if (this.clusters.cluster6.output24.attributes && this.clusters.cluster6.output24.attributes.wysokosc) {
            // otherIndex = (this.clusters.cluster6.output24.grupa === 'other') ? (Number(this.clusters.cluster6.output24.attributes.wysokosc - 1) * 15) : 0
            arr.push({'grupa': this.clusters.cluster6.output24.grupa, 'wysokosc': this.clusters.cluster6.output24.attributes.wysokosc, 'top': index})
            index += Number(this.clusters.cluster6.output24.attributes.wysokosc) * 15
          }
        }
        return arr
      } else {
        return []
      }
    },
    getImgUrlAkumC1 () {
      var akumUrl = (this.outputs.akumulators.c1.pojemnosc) ? 'akumulator/akum_' + this.outputs.akumulators.c1.pojemnosc + '.png' : ''
      return akumUrl
    },
    getImgUrlAkumC2 () {
      var akumUrl = (this.outputs.akumulators.c2.pojemnosc) ? 'akumulator/akum_' + this.outputs.akumulators.c2.pojemnosc + '.png' : ''
      return akumUrl
    },
    getImgUrlAkumC3 () {
      var akumUrl = (this.outputs.akumulators.c3.pojemnosc) ? 'akumulator/akum_' + this.outputs.akumulators.c3.pojemnosc + '.png' : ''
      return akumUrl
    },
    getImgUrlAkumC4 () {
      var akumUrl = (this.outputs.akumulators.c4.pojemnosc) ? 'akumulator/akum_' + this.outputs.akumulators.c4.pojemnosc + '.png' : ''
      return akumUrl
    },
    getImgUrlAkumC5 () {
      var akumUrl = (this.outputs.akumulators.c5.pojemnosc) ? 'akumulator/akum_' + this.outputs.akumulators.c5.pojemnosc + '.png' : ''
      return akumUrl
    },
    getImgUrlAkumC6 () {
      var akumUrl = (this.outputs.akumulators.c6.pojemnosc) ? 'akumulator/akum_' + this.outputs.akumulators.c6.pojemnosc + '.png' : ''
      return akumUrl
    },
    iloscU () {
      return (this.outputs.szafa.attributes.wysokosc === '') ? '24' : this.outputs.szafa.attributes.wysokosc
    },
    imgKolka () {
      return (this.inputs.kolka.value === '1' || this.inputs.kolka.value === 1) ? 'dso_kolka.svg' : 'dso_cokol.svg'
    },
    heightAkumulator () {
      var wysokoscAkumulatora = 7 // this.outputs.akumulator.wysokosc
      return (wysokoscAkumulatora > 0) ? (wysokoscAkumulatora * 3) * 5 : 0
    },
    heightListwa () {
      return (this.sprawdzAkumulatoryNaPolkach && this.sprawdzAkumulatoryNaPolkach.length > 0) ? (this.heightAkumulator * this.sprawdzAkumulatoryNaPolkach.length) : (this.heightAkumulator * this.iloscAkumulatorow.polki)
    },
    heightPanelMount () {
      return this.heightListwa + 45
    },
    heightMikrofonMount () {
      return this.heightPanelMount + 15
    },
    topAkumulator () {
      return 0
    },
    iloscAkumulatorow () {
      var value = 0
      Object.keys(this.outputs.akumulators).forEach(element => {
        if (this.outputs.akumulators[element]) {
          value++
        }
      })
      var polki = Math.ceil(value / 2)
      return {value, polki}
    },
    sprawdzAkumulatoryNaPolkach () {
      var glebokosc = this.inputs.glebokosc_szafy.value
      var allBatteries = []
      Object.keys(this.outputs.akumulators).forEach(element => {
        if (this.outputs.akumulators[element]) {
          allBatteries.push(this.outputs.akumulators[element].pojemnosc)
        }
      })
      var shelfBatteriesSmall = []
      var shelfBatteriesBig = []
      var perChunkSmall = 0 // items per chunk
      var perChunkBig = 0 // items per chunk
      var resultSmall = []
      var resultBig = []
      var allShelfs = []

      if (glebokosc === 600 || glebokosc === '600') {
        // szafa 600
        allBatteries.forEach(element => {
          if (Number(element) === 200 || Number(element) === 230) {
            shelfBatteriesBig.push(element)
          } else {
            shelfBatteriesSmall.push(element)
          }
        })

        perChunkSmall = 2 // items per chunk
        resultSmall = shelfBatteriesSmall.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / perChunkSmall)
          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [] // start a new chunk
          }
          resultArray[chunkIndex].push(item)
          return resultArray
        }, [])

        perChunkBig = 1 // items per chunk
        resultBig = shelfBatteriesBig.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / perChunkBig)
          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [] // start a new chunk
          }
          resultArray[chunkIndex].push(item)
          return resultArray
        }, [])

        if (resultSmall.length > 0 && resultSmall.length > 0) {
          allShelfs = [...resultSmall, ...resultBig]
        } else {
          if (resultSmall.length > 0) {
            allShelfs = [...resultSmall]
          }
          if (resultBig.length > 0) {
            allShelfs = [...resultBig]
          }
        }
        // console.log(allBatteries)
        // console.log(allShelfs)
      } else {
        // szafa 800
        allBatteries.forEach(element => {
          if (Number(element) === 160 || Number(element) === 200 || Number(element) === 230) {
            shelfBatteriesBig.push(element)
          } else {
            shelfBatteriesSmall.push(element)
          }
        })
        // console.log('--- allBatteries ---')
        // console.log(allBatteries)

        perChunkSmall = 3 // items per chunk
        resultSmall = shelfBatteriesSmall.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / perChunkSmall)
          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [] // start a new chunk
          }
          resultArray[chunkIndex].push(item)
          return resultArray
        }, [])
        var resultSmallTemp = JSON.parse(JSON.stringify(resultSmall))

        var arrResztaSmall = []
        if (resultSmallTemp && resultSmallTemp[resultSmall.length - 1] && (resultSmallTemp[resultSmall.length - 1]).length < 2) {
          arrResztaSmall = JSON.parse(JSON.stringify(resultSmallTemp[resultSmallTemp.length - 1]))
          resultSmall.pop()
        }
        if (arrResztaSmall[0]) {
          shelfBatteriesBig.push(arrResztaSmall[0])
          shelfBatteriesBig.sort()
        }

        perChunkBig = 2 // items per chunk
        resultBig = shelfBatteriesBig.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / perChunkBig)
          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [] // start a new chunk
          }
          resultArray[chunkIndex].push(item)
          return resultArray
        }, [])

        if (resultSmall.length > 0 && resultSmall.length > 0) {
          allShelfs = [...resultSmall, ...resultBig]
        } else {
          if (resultSmall.length > 0) {
            allShelfs = [...resultSmall]
          }
          if (resultBig.length > 0) {
            allShelfs = [...resultBig]
          }
        }
        // console.log(allShelfs)
      }
      return allShelfs
    },
    iloscZaslepek () {
      var iloscUreszta = Number(Math.round(this.outputs.szafa_wolne_miejsce.value / 3))
      var numer = 4
      var zaslepki = {}

      while (numer > 0) {
        var rapz = Math.floor(iloscUreszta / numer)
        if (rapz > 0) {
          iloscUreszta -= Number(rapz * numer)
          zaslepki['rapz' + numer] = rapz
        }
        numer--
      }
      return zaslepki
    }
  },
  methods: {
    BgImageTop (src) {
      let bgImage = require('@/assets/img/' + src)
      return {
        backgroundImage: `url("${bgImage}")`
      }
    },
    BgImageBottom (src) {
      let bgImage = require('@/assets/img/urzadzenia/' + src)
      return {
        backgroundImage: `url("${bgImage}")`
      }
    },
    BgImageAkumulator (src) {
      let bgImage = require('@/assets/img/akumulator/akum_' + src + '.png')
      return {
        backgroundImage: `url("${bgImage}")`
      }
    },
    BgImageAkumulatorPoziom (src) {
      let bgImage = require('@/assets/img/akumulator/akum_' + src + '_poziom.png')
      return {
        backgroundImage: `url("${bgImage}")`
      }
    },
    topDevice (nr, wysokosc) {
      return (nr * 32.8)
      // return (this.outputs.szafa.attributes.wysokosc === '') ? '24' : this.outputs.szafa.attributes.wysokosc
    },
    changeTop (cluster, val) {
      let wys = 0
      if (cluster === 'panel') {
        this.heightPanel = val
        wys = val
      } else if (cluster === 'c1') {
        this.heightCluster1 = val + 5
        wys = val + 5
      } else if (cluster === 'c2') {
        this.heightCluster2 = val + 5
        wys = val + 5
      } else if (cluster === 'c3') {
        this.heightCluster3 = val + 5
        wys = val + 5
      } else if (cluster === 'c4') {
        this.heightCluster4 = val + 5
        wys = val + 5
      } else if (cluster === 'c5') {
        this.heightCluster5 = val + 5
        wys = val + 5
      }
      this.mount_place_empty(wys)
    },
    cosik (id) {
      console.log(id)
    },
    mount_place_empty (wys) {
      this.startWolneMiejsce = wys
    }
    // topElementy (index) {
    //   return index * 40.6
    // }
  }
}
</script>
<style scoped>
#Wizualizacja {
  height: 100%;
}
#Wizualizacja img {
  width: 250px;
  position: absolute;
  bottom: 0px;
  left: 85px;
}
#szafa {
  width: 250px;
  height: 790px;
  position: absolute;
  left: 10px;
  bottom: 0px;
  bottom: -80px;
  transform: scale(0.8);
}
#szafa-top {
  width: 250px;
  height: 790px;
  /* background-image:  url("../assets/szafa_dso_24.svg"); */
  position: absolute;
  bottom: 34px;
}
#szafa-bottom {
  width: 250px;
  height: 35px;
  background-image:  url("../assets/img/urzadzenia/dso_cokol.svg");
  position: absolute;
  bottom: 0px;
}

#obudowy {
  width: 85px;
  position: absolute;
  left: 250px;
  bottom: 0px;
  bottom: 0px;
  -webkit-transform: scale(1);
  transform: scale(1);
  background: none;
  padding: 6px;
  border: 2px solid #ccc;
}
#obudowy img {
  width: 100%;
  left: 0px;
  position: relative;
  margin: 4px 0px;
}
#grupa_otworow {
  position:absolute; bottom:20px;left: 13px;
}
.otwory_montazowe {
  width:224px; height:5px; background:rgba(0,0,0,.1);
  margin-bottom:0px;
  text-align: left;
  position: relative;
}

.otwory_montazowe span{
  position: absolute;
  left: -12px;
  font-size: 10px;
}

.wentylator {
  width: 224px; height: 15px; background: rgb(0, 0, 0); position: absolute;
  background-image:  url("../assets/img/urzadzenia/wentylator.png");
  background-size: contain;
  text-align: left; padding: 0px 0px; color: white;
  z-index: 999;
}
.wzmacniacz {
  width: 224px; height: 30px; background: rgb(0, 0, 0); position: absolute;
  background-image:  url("../assets/img/urzadzenia/bg_bosch.png");
  background-size: contain;
  text-align: left; padding: 0px 10px; color: white;
  z-index: 999;
}
.wzmacniacz_rez {
  width: 224px; height: 30px; background: rgb(0, 0, 0); position: absolute;
  background-image:  url("../assets/img/urzadzenia/bg_bosch.png");
  background-size: contain;
  text-align: left; padding: 0px 10px; color: white;
  z-index: 999;
}
.router {
  width: 224px; height: 30px; background: rgb(0, 0, 0); position: absolute;
  background-image:  url("../assets/img/urzadzenia/bg_bosch.png");
  background-size: contain;
  text-align: left; padding: 0px 10px; color: white;
  z-index: 999;
}
.kontroler {
  width: 224px; height: 30px; background: rgb(0, 0, 0); position: absolute;
  background-image:  url("../assets/img/urzadzenia/bg_bosch.png");
  background-size: contain;
  text-align: left; padding: 0px 10px; color: white;
  z-index: 999;
}
.stale_elementy {
  width: 224px; position: absolute;
  text-align: left; padding: 0px 0px; color: white;
  left: 0px;
  }
.zasilacz {
  width: 224px; height: 30px; background: rgb(51, 51, 51); position: absolute;
  background-image:  url("../assets/img/urzadzenia/zasilacz.png");
  background-size: contain; background-repeat: no-repeat;
  text-align: left; padding: 0px 0px; color: white;
  z-index: 999;
}
.sterownik {
  width: 224px; height: 15px; background: rgb(51, 51, 51); position: absolute;
  background-image:  url("../assets/img/urzadzenia/sterownik_systemu.png");
  background-size: contain; background-repeat: no-repeat;
  text-align: left; padding: 0px 0px; color: white;
  z-index: 999;
}
.wzmacniacz4 {
  width: 224px; height: 15px; background: rgb(0, 0, 0); position: absolute;
  background-image:  url("../assets/img/urzadzenia/wzmacniacz4.png");
  background-size: contain; background-repeat: no-repeat;
  text-align: left; padding: 0px 0px; color: white;
  z-index: 999;
}
.wzmacniacz8 {
  width: 224px; height: 15px; background: rgb(0, 0, 0); position: absolute;
  background-image:  url("../assets/img/urzadzenia/wzmacniacz8.png");
  background-size: contain; background-repeat: no-repeat;
  text-align: left; padding: 0px 0px; color: white;
  z-index: 999;
}
.mikrofon {
  width: 225px; height: 75px; background:rgba(191, 191, 191, 0.8); position: absolute;
  background-image:  url("../assets/img/urzadzenia/mikrofon.png");
  background-size: cover;
  text-align: left; padding: 0px 0px; color: white;
  z-index: 999;
}
.panel_sygnalizacyjny {
  width: 224px; height: 15px; background: rgb(51, 51, 51); position: absolute;
  background-image:  url("../assets/img/urzadzenia/panel_sygnalizacyjny.svg");
  background-size: cover;  background-repeat: no-repeat;
  z-index: 999;
}
.listwa {
  width: 224px; height: 45px; background: rgb(51, 51, 51); position: absolute;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 999;
}
.akumulator {
  width: 224px; background: rgba(191, 191, 191, 0.8); position: absolute;
  /* background-image:  url("../assets/img/urzadzenia/akum_600_35.svg"); */
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 999;
}
.polka_akumulator {
  width: 224px; height: 5px; background: rgb(0, 0, 0); position: absolute;
  /* background-image:  url("../assets/img/urzadzenia/akum_600_35.svg"); */
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 999;
  bottom:0px
}
.akumulator_left {
  width: 112.5px; height: 100px; position: absolute;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 5;
}
.akumulator_right {
  width: 112.5px; height: 100px; position: absolute;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 5;
  right: 0px;
}
.akumulator_back {
  width: 225px; height: 100px; position: absolute;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 2;
}
.other {
  width: 224px;
  background: linear-gradient(0.25turn, #3c3c3c, #7d7d7d, #3c3c3c);
  /* background: rgb(51, 51, 51);  */
  position: absolute;
  text-align: left; padding: 0px 0px; color: white;
  z-index: 999;
}
.zaslepka {
  width: 225px; height: 16.4px; background: rgb(51, 51, 51); position: absolute;
  background-image:  url("../assets/img/urzadzenia/zaslepka.png");
  background-size: contain;
  text-align: left; padding: 0px 0px; color: white;
  z-index: 999;
}
.wolne-miejsce {
  width: 225px; height: 16.4px; background: rgba(216, 255, 208, 0.4); position: absolute;
  text-align: left; padding: 0px 0px; color: white;
  z-index: 999;
}
.pojAkum {
position: absolute;
top: 50px;
color: white;
left: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/Wizualizacja.vue